import { render, staticRenderFns } from "./ReadOnlyEditor.vue?vue&type=template&id=380c00df&scoped=true"
import script from "./ReadOnlyEditor.vue?vue&type=script&lang=js"
export * from "./ReadOnlyEditor.vue?vue&type=script&lang=js"
import style0 from "./ReadOnlyEditor.vue?vue&type=style&index=0&id=380c00df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c00df",
  null
  
)

export default component.exports